export class TaikyoNotificationEntity {
    bulkTaikyoNo = "";
    tantoshaName = "";
    tantoshaTel = "";
    tantoshaEmail = "";
    isKouzaNotRequired = false;
    henkinBankCd = null;
    henkinBansCd = null;
    henkinBankName = "";
    henkinBansName = "";
    henkinKouzaSb = 0;
    henkinKouzaNo = "";
    henkinKouzaKana = "";
    henkinKouzaName = "";
    taikyoGuide = "";
    taikyoList = [];
}
export class Taikyo {
    nyukyosha = "";
    bukkenName = "";
    roomNumber = "";
    shopName = "";
    nyukyokeiyakuNo = -1;
    taikyoNo = -1;
    status = 0;
    taikyoYmd = null;
    kaiyakuYmd = null;
    kaiyakuStrYmd = "";
    taikyoRiyuKb = null;
    taikyoRiyuKbName = "";
    taikyoRiyu = "";
    sonotaKeiyaku = "";
    keyReturnName = "";
    keyReturnNameKb = null;
    keyReturnYmd = null;
    keyReturnStrYmd = "";
    keyReturnStrTime = "00:00";
    numberOfReturnKeys = null;
    taikyoTachiaiKb = null;
    taikyoTachiaiKbName = "";
    taikyoTachiaiName = "";
    renrakuKb = null;
    renrakuName = "";
    renrakuRelationship = "";
    tel = "";
    email = "";
    keyReturnAdrKb = null;
    soufuName = "";
    postCode = "";
    adr1 = "";
    adr2 = "";
    adr3 = "";
    soufuSonota = "";
    shinseiYmd = null;
    files = [];
    fileList = [];
    isDeleted = false;
}
export class AttachedFile {
    fileId = "";
    fileKb = -1;
    fileName = "";
    delFlg = false;
    newFlg = false;
}
